import {createI18n} from '@soopkr-fe/soop-i18n';
import '@soopkr-fe/soop-i18n/starrank';

const i18n = createI18n({
  namespaces: ['starrank'],
});

export const StarrankT = i18n.t;
export const StarrankI18n = i18n;
